// extracted by mini-css-extract-plugin
export default {"FormButtons":"FormButtons_FormButtons__GWqTJ","SubmitButton":"FormButtons_SubmitButton__1Zce2"};